module.exports = __webpack_public_path__ + "img/img1.bd19fbfb.png";